/**
 * @method format: 时间格式转换
 * @param fmt {String}:
 * yyyy-MM-dd hh:mm:ss.S ==> 2020-07-02 08:09:04.423
 * yyyy-M-d h:m:s.S ==> 2020-7-2 8:9:4.18
 * new Date().format("yyyy-MM-dd hh:mm:ss");
 */
Date.prototype.format = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1,
    'd+': this.getDate(),
    'h+': this.getHours(),
    'm+': this.getMinutes(),
    's+': this.getSeconds(),
    'q+': Math.floor((this.getMonth() + 3) / 3),
    'S': this.getMilliseconds()
  };
  if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length)); }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) { fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))); }
  }
  return fmt;
};

Date.prototype.getChineseWeek = function (val) {
  let weekDay = this.getDay();
  switch (weekDay) {
    case 0 :
      return '日';
    case 1 :
      return '一';
    case 2 :
      return '二';
    case 3 :
      return '三';
    case 4 :
      return '四';
    case 5 :
      return '五';
    case 6 :
      return '六';
  }
};
